import { useState, useMemo, FunctionComponent, useEffect, useRef } from "react";
// import alerticonError from "../../assets/error-message-icon/alert-icon-error.svg";
import dowpDowniconimg from "../../assets/task/dropdown_iconimg.svg";
// import otlchevronforward1 from "../../assets/otlchevronforward1@2x.png";

interface InputsDropdownMultipleSeachSelectProps {
    label: string;
    placeHolder?: string;
    propMinWidth?: string;
    options: any;
    onSelect?: any;
    errorMessage?: any;
    initialValue?: string;
    disableDropdown?: boolean;
    showSearchable?: boolean;
    clearSelected?: any;
    errorMessage1?: any;
    checkedItems?: any;
    inputType?: any;
}

const InputsDropdownMultipleSearchSelect: FunctionComponent<
    InputsDropdownMultipleSeachSelectProps
> = ({
    label,
    placeHolder,
    options,
    onSelect,
    errorMessage,
    initialValue,
    disableDropdown,
    errorMessage1,
    clearSelected,
    showSearchable,
    inputType,
    checkedItems,
}) => {
        const [isOpen, setIsOpen] = useState(false);
        const [selectedOption, setSelectedOption] = useState(
            initialValue || placeHolder
        );
        const dropdownRef = useRef<HTMLDivElement>(null);
        const [inputValue, setInputValue] = useState<any>(""); // For search input

        useEffect(() => {
            if (clearSelected) {
                setSelectedOption(placeHolder);
            }
        }, [clearSelected]);

        // Effect to handle initial value setting
        useEffect(() => {
            if (
                initialValue !== undefined &&
                initialValue !== "" &&
                initialValue !== null
            ) {
                setSelectedOption(initialValue);
                // setLastSelectedOption(initialValue); //added for new feature
            }
        }, [initialValue]);

        useEffect(() => {
            function handleClickOutside(event: MouseEvent) {
                if (
                    dropdownRef.current &&
                    !dropdownRef.current.contains(event.target as Node)
                ) {
                    setIsOpen(false);
                    setInputValue("");
                }
            }

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [dropdownRef]);

        function handleDropdownToggle() {
            if (!disableDropdown) {
                setIsOpen(!isOpen);
                if (!isOpen) {
                    setInputValue(""); // Reset search input when opening the dropdown
                }
            }
        }

        function handleOptionSelect(
            key: any,
            name: any,
            type?: any,
            index?: any,
            matchedArray?: any
        ) {
            if (onSelect) {
                if (inputType === "radio") {
                    setIsOpen(false)
                    setSelectedOption(name);
                }
                onSelect(key, name, type);
            }
        }

        // Filtering options based on search input
        const filteredOptions = useMemo(
            () =>
                options?.filter((option: any) =>
                    option?.name?.toLowerCase()?.includes(inputValue?.toLowerCase())
                ),
            [inputValue, options]
        );

        // Grouping filtered options by type
        const groupedOptions = filteredOptions.reduce((acc: any, option: any) => {
            if (!acc[option.type]) {
                acc[option.type] = [];
            }
            acc[option.type].push(option);
            return acc;
        }, {});

        // Determine border class based on errorMessage
        const borderClass =
            errorMessage || errorMessage1
                ? "border-2 border-rose-500 dark:border-rose-500 darkinputborder"
                : "border-surface-border";

        return (
            <div
                id="addinterration-blg-dv"
                className={`relative flex-1 inputnew-div cts-flex1-remd flex flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg w-full`}
                ref={dropdownRef}
            >
                <label className="self-stretch relative font-semibold pb-2 dark:text-white">
                    {label}
                </label>
                <div className="self-stretch flex flex-col items-start justify-start text-text-text-secondary dark:text-white">
                    <div
                        id="cts-dropdown-dv"
                        className={`border-surface-border-blg-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary dark:bg-slate-700 overflow-hidden h-[20px] flex flex-row items-center justify-start py-2.5 px-[15px] gap-[8px] border-[1px] border-solid ${borderClass} mq450:flex-nowrap`}
                        onClick={handleDropdownToggle}
                    >
                        <input
                            type="text"
                            className="flex-1 bg-transparent border-none outline-none text-gray-500 dark:text-white"
                            placeholder={selectedOption}
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                setIsOpen(true); // Keep dropdown open while searching
                            }}
                            onClick={() => setIsOpen(true)}
                        />

                        <img
                            className={`h-4 w-4 relative overflow-hidden shrink-0 object-contain transform transition-transform ${isOpen ? "rotate-180" : ""
                                }`}
                            alt=""
                            src={dowpDowniconimg}
                        />
                    </div>
                    {isOpen && (
                        <div className="cts-zindex-dv border-surface-border-blg-dv absolute left-0 mt-11 w-full self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-white border-[1px] border-solid border-surface-border z-50">
                            {Object.entries(groupedOptions)?.length > 0 ? (
                                <>
                                    {/* "Select All" Checkbox */}
                                    <div className="py-2 px-[15px] hover:bg-gray-100 dark:hover:dark:bg-slate-500 cursor-pointer dropdowncheckbox-option">
                                        {inputType === "checkbox" && (
                                            <label className="flex items-center cursor-pointer labl-dropdowncheckbox-option">
                                                <input
                                                    type="checkbox"
                                                    name={"Select All"}
                                                    className="mr-2 cursor-pointer"
                                                    checked={
                                                        // Check if all items in all groups are selected
                                                        checkedItems?.length ===
                                                        Object.values(groupedOptions).flat().length
                                                    }
                                                    onChange={() =>
                                                        handleOptionSelect(
                                                            "all",
                                                            checkedItems?.length ===
                                                            Object.values(groupedOptions).flat().length
                                                        )
                                                    }
                                                />
                                                Select All
                                            </label>
                                        )}
                                    </div>

                                    {/* Grouped Options */}
                                    {Object.entries(groupedOptions).map(
                                        ([type, items]: [any, any]) => {
                                            return (
                                                <div key={type} className="multpleselectinnerdropdown-dv">
                                                    {type && type != "undefined" && (
                                                        <p className="text-sm px-[15px] font-semibold label-p-dv capitalize">
                                                            {type}
                                                        </p>
                                                    )}

                                                    {items.map((option: any, index: any) => {
                                                        const checked =
                                                            inputType === "radio"
                                                                ? option.key === checkedItems
                                                                : checkedItems?.some(
                                                                    (it: any) => it.name?.toLowerCase() === option.name?.toLowerCase()
                                                                );
                                                        return (
                                                            <div
                                                                key={index}
                                                                className={`py-2 px-[15px] hover:bg-gray-100 dark:hover:dark:bg-slate-500 cursor-pointer inner-dropdowncheckbox-option ${checked ? "bg-gray-200 dark:bg-slate-600 font-semibold" : ""
                                                                    }`}
                                                                onClick={() =>
                                                                    handleOptionSelect(option.key, option.name, option?.type)
                                                                }
                                                            >
                                                                {/* Hide the actual input when inputType is radio */}
                                                                {inputType === "checkbox" && (
                                                                    <input
                                                                        type="checkbox"
                                                                        className="mr-2 cursor-pointer"
                                                                        checked={checked}
                                                                        // onChange={() =>
                                                                        //     handleOptionSelect(option.key, option.name, option?.type)
                                                                        // }
                                                                    />
                                                                )}
                                                                <span>{option.name}</span>
                                                            </div>
                                                        );
                                                        // return (
                                                        //     <div
                                                        //         key={index}
                                                        //         className="py-2 px-[15px] hover:bg-gray-100 dark:hover:dark:bg-slate-500 cursor-pointer inner-dropdowncheckbox-option"
                                                        //     >
                                                        //         <label className="flex items-center cursor-pointer">
                                                        //             <input
                                                        //                 type={inputType}
                                                        //                 name={
                                                        //                     inputType === "radio"
                                                        //                         ? option.type
                                                        //                         : undefined
                                                        //                 }
                                                        //                 className="mr-2 cursor-pointer"
                                                        //                 checked={checked}
                                                        //                 onChange={() =>
                                                        //                     handleOptionSelect(
                                                        //                         option.key,
                                                        //                         option.name,
                                                        //                         option?.type
                                                        //                     )
                                                        //                 }
                                                        //             />
                                                        //             {option.name}
                                                        //         </label>
                                                        //     </div>
                                                        // );
                                                    })}
                                                </div>
                                            );
                                        }
                                    )}
                                </>
                            ) : (
                                <div className="py-2 px-[15px] text-center text-gray-500">
                                    No options found
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {errorMessage && (
                    <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg mt-2">
                        <img src={""} alt="" /> {errorMessage.message}
                    </p>
                )}
            </div>
        );
    };

export default InputsDropdownMultipleSearchSelect;
